<template>
  <div class="copy-link">
    <div class="copy-link__wrapper copy-link-wrap">
        <div class="copy-link-wrap__link" ref="slotContent">
          <slot/>
        </div>
        <button class="copy-link-wrap__copy-btn" @click="copyContent">
          <!-- <span class="copy-link-wrap__copy-btn--copied" v-if="isCopied">Скопировано!</span> -->
          <CheckedIcon class="copy-link-wrap__copy-btn--checked" v-if="isCopied"/>
          <CopyIcon class="copy-link-wrap__copy-btn--unchecked" v-else/>
        </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CopyIcon from '@/assets/icons/copy-icon.svg'
import CheckedIcon from '@/assets/icons/checked-icon.svg'
import { ref } from 'vue';

const slotContent = ref<HTMLElement | null>(null);
const isCopied = ref(false);

const copyContent = async () => {
  if (slotContent.value?.textContent && !isCopied.value) {
    try {
      await navigator.clipboard.writeText(slotContent.value.textContent.trim());
      isCopied.value = true;
      setTimeout(() => {
        isCopied.value = false;
      }, 2000);
    } catch (err) {
      console.error('Не удалось скопировать текст: ', err);
    }
  }
};
</script>

<style lang="scss">
.copy-link-wrap {
  position: relative;
    border: 1px solid white;
    height: 48px;
    width: 100%;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 16px 20px;
    color: $neutral-100;

    &__copy-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $neutral-100;
      // min-width: 80px; // Для предотвращения скачка размера
      text-align: center;

      &--checked {
        position: absolute;
        right: 15px;
      }

      &--unchecked {
        position: absolute;
        right: 15px;
      }
    }
}
</style>